import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { loadTrcaSchema } from "@/lib/trcaSchema";

export default function TrcaSchemaGate({ children }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let alive = true;
    Promise.resolve(loadTrcaSchema(api)).finally(() => alive && setReady(true));
    return () => { alive = false; };
  }, []);
  if (!ready) return <div className="p-10 text-sm text-ink-muted uppercase tracking-wider" data-testid="trca-schema-loading">Loading assessment…</div>;
  return children;
}
